export const enum AUTH_FLOW {
  BASIC = 'BASIC',
  CHECK_EMAIL = 'CHECK_EMAIL',
  FIRST_SIGN_IN = 'FIRST_SIGN_IN',
  MFA_CHECK = 'MFA_CHECK',
  MFA_SETUP = 'MFA_SETUP',
  MFA_SETUP_COMPLETED = 'MFA_SETUP_COMPLETED',
  UNCONFIRMED = 'UNCONFIRMED',
  WITH_INVITATION_CODE = 'WITH_INVITATION_CODE',
}
